import FormSelect from 'components/Select/FormSelect';
import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetSubCategoriesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getSubCategoriesShortInfo } from 'backend/subcategories';

interface IDishModificationSubCategorySelect {
	setDishModificationSubCategory: (value: Nullable<string>) => void;
	setFetchedDishModificationSubCategories: (value: IItemForGetShortInfo[]) => void;
	selectedDishModificationCategory: Nullable<string>;
}

const DishModificationSubCategorySelect: React.FC<IDishModificationSubCategorySelect> = ({
	selectedDishModificationCategory,
	setDishModificationSubCategory,
	setFetchedDishModificationSubCategories,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetSubCategoriesShort, string[]>(
		selectedDishModificationCategory ? getSubCategoriesShortInfo : null,
		selectedDishModificationCategory ? [selectedDishModificationCategory] : [],
	);

	useEffect(() => {
		refetch();
	}, [selectedDishModificationCategory]);

	useEffect(() => {
		response && setFetchedDishModificationSubCategories(response.data.subCategories);
	}, [response]);

	return (
		<FormSelect
			name="selectedDishModificationSubCategory"
			label="subcategoryLabel"
			options={response?.data.subCategories}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			disabled={!selectedDishModificationCategory || loading}
			onChange={setDishModificationSubCategory}
		/>
	);
};

export default React.memo(DishModificationSubCategorySelect);
